import { CatchAPIService, MerchantId, SetHeaderService } from "@/helper/userHelper";
import { i18n } from "@/i18n";
import service from "../baseHttpService";

class ProductService {
  DoGetAllProductTemplate(isUseMainDatabase = false) {
    const input: any = {
      merchantId: MerchantId(),
      language: i18n.locale,
      isUseMainDatabase: isUseMainDatabase,
    };
    return service.peakExportAPI
      .post("/api/Product/GetAllProductTemplate", input, SetHeaderService())
      .then((res) => {
        return res;
      })
      .catch((err) => CatchAPIService(err.response));
  }
}

export default new ProductService();
